import { useNavigate } from "react-router-dom";
import EditNodalOfficerForm from "../../components/Admin/EditNodalOfficerForm";
import Button from "../../components/common/Button";
import DashboardLayout from "../../components/Layout/DashboardLayout";

const EditNodalOfficer = () => {
  const navigate = useNavigate();
  const showDistrict = history.state?.usr?.showDistrict || false;
  return (
    <DashboardLayout pageTitle="Profile" mainClass="p-6">
      <div className="flex justify-end mb-4">
        <Button
          className="bg-btn font-semibold py-2 px-4 rounded-md"
          onClick={() =>
            navigate(
              showDistrict
                ? "/admin/district-officers"
                : "/admin/state-officers"
            )
          }
        >
          Back
        </Button>
      </div>
      <div className="flex h-12 nav-bg p-3 text-white font-semibold rounded-tr rounded-tl">
        Edit Profile
      </div>
      <div className="bg-white p-6 rounded-b shadow-md mx-auto">
        <EditNodalOfficerForm />
      </div>
    </DashboardLayout>
  );
};

export default EditNodalOfficer;
